// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Message } from './models/Message';

export const MessageSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const SendingEventExtSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const MessageStore = types
  .compose(
    getBaseStore<Instance<typeof Message>, Instance<typeof Message>>(Message, 'messageId', 'message'),
    types.model('MessageStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const updateMessageInStore = (msg: Instance<typeof Message>) => {
      const msgModel = Message.create(msg);
      self.datas.put(msgModel);
      return msgModel;
    };

    const searchSendingEventExt = flow(function*(criteria: Instance<typeof SendingEventExtSearch>) {
      const result = yield apiFetcher.get('message/history', {
        params: criteria,
      });
      const resultMsg: Array<Instance<typeof SendingEventExt>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdMsg = updateMessageInStore(node);
        resultMsg.push(createdMsg);
      });
      return resultMsg;
    });
    const search = flow(function*(criteria: Instance<typeof MessageSearchCriteria>) {
      const result = yield apiFetcher.get('message', {
        params: criteria,
      });
      const resultMsg: Array<Instance<typeof Message>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdMsg = updateMessageInStore(node);
        resultMsg.push(createdMsg);
      });
      return resultMsg;
    });

    const sendMessage = flow(function*(data: any) {
      const res = yield env.api.post('message/Send/withContent', data);
      // @ts-ignore
      updateMessageInStore(res);
    });

    const resendMessage = flow(function*(sendingId: number) {
      const res = yield env.api.get('message/resend/' + sendingId, {});
    });

    const sendPreview = flow(function*(data: any) {
      try {
        const res = yield env.api.post('message/Preview/withContent', data);
        if ((res as any).length !== 0) {
          // @ts-ignore
          updateMessageInStore(res);
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    });

    return { search, searchSendingEventExt, sendMessage, sendPreview, resendMessage };
  });

export type MessageStoreType = Instance<typeof MessageStore>;
